import React from 'react';
import classNames from 'classnames';
import AppLoaderSVG from '@/assets/app_loader.svg';

import styles from './AppLoader.module.css';

export default function AppLoader() {
  return (
    <div className={classNames(styles['loader-container'], 'background-container')}>
      <div className={styles['spinner']}>
        <AppLoaderSVG />
      </div>
    </div>
  );
}
